/**
 * View for the action item creator wizard
 */
define([
  "marionette",
  "modules/actions/actionGroup/actionItemModal/template/actionItemModalTemplate.html",
], function (Marionette, ActionItemModalTemplate) {
  var ActionItemModalView = {};

  ActionItemModalView.actionItemModalLayout = Marionette.Layout.extend({
    template: ActionItemModalTemplate,
    regions: {
      actionItemStep: "#actionItemStep",
      actionItemSelect: "#actionItemSelect",
    },
    triggers: {
      "click #backButton": "back",
      "click #nextButton": "next",
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    hideBackButton: function () {
      this.$el.find("#backButton").hide();
    },
    showBackButton: function () {
      this.$el.find("#backButton").show();
    },
    hideNextButton: function () {
      this.$el.find("#nextButton").hide();
    },
    showNextButton: function () {
      this.$el.find("#nextButton").show();
    },
    hideDoneButton: function () {
      this.$el.find("#doneButton").hide();
    },
    showDoneButton: function () {
      this.$el.find("#doneButton").show();
    },
  });

  return ActionItemModalView;
});
